module.exports = __webpack_public_path__ + "img/flecha.397d03b8.svg";